import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./installation-query-key-factory";

/**
 * Gets the installation org count
 */
export const getInstallationOrganizationCount = ({ installationId }: { installationId: string | null }) => {
  return installationId === null
    ? Promise.reject(new Error("Invalid installationId id"))
    : Brm.installationApi.getInstallationOrganizationCount(installationId);
};

interface IInstallationProps {
  installationId: string | null;
  options?: QueryOption<typeof getInstallationOrganizationCount>;
}

/**
 * Custom hook for getting the installation org count
 *
 * @param {string} installationId - uuid of user
 * @param {object} config - react-query configuration
 * @returns
 */
export const useInstallationOrganizationCount = ({ installationId, options = {} }: IInstallationProps) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.installationKeys.orgCount(installationId),
    queryFn: () => getInstallationOrganizationCount({ installationId }),
  });
};
